import AgreementService from "@/app/services/AgreementService.js"
import { types } from "@/app/types/types";

const state =
{
	[types.STATE_AGREEMENTS]: []
};

const getters =
{
	[types.GET_AGREEMENTS]: (state) =>
	{
		return state[types.STATE_AGREEMENTS]
	},

	[types.GET_AGREEMENT]: (state, id) =>
	{
		var agreements = state[types.STATE_AGREEMENTS];

		for (const agreement of agreements)
		{
			if (agreement.id == id)
				return agreement;
		}

		return null;
	}
};

const mutations =
{
	[types.MUTATE_LOAD_AGREEMENTS]: (state, payload) =>
	{
		// TODO: Do paging here
		state[types.STATE_AGREEMENTS] = payload
	},

	[types.MUTATE_ADD_AGREEMENT]: (state, payload) =>
	{
		state[types.STATE_AGREEMENTS].push(payload);
	},

	[types.MUTATE_UPDATE_AGREEMENT]: (state, payload) =>
	{
		//let index = state[types.STATE_AGREEMENTS].findIndex(agreement => agreement.id == payload.id)
		//state[types.STATE_AGREEMENTS].splice(index, 1, payload)
		let agreement = state[types.STATE_AGREEMENTS].find((agreement) => { return agreement.id == payload.id });

		if (agreement)
		{
			agreement = payload
		}
	},

	[types.MUTATE_DELETE_AGREEMENT]: (state, payload) =>
	{
		//let index = state[types.STATE_AGREEMENTS].findIndex(agreement => agreement.id == payload.id)
		//state[types.STATE_AGREEMENTS].splice(index, 1)
		state[types.STATE_AGREEMENTS] = state[types.STATE_AGREEMENTS].filter((agreement) => { return agreement.id !== payload });
	}
};

const actions =
{
	[types.ACTION_GET_AGREEMENTS]: ({ commit }, payload) =>
	{
		commit(types.MUTATE_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_GET_AGREEMENTS, payload: payload })
		
		return AgreementService.getAgreements(payload).then(response =>
		{
			commit(types.MUTATE_LOAD_AGREEMENTS, response.data);
			return response
		}).catch(error =>
		{
			commit(types.MUTATE_ADD_ERRORLOG_ENTRY, { reference: types.ACTION_GET_AGREEMENTS, message: error, payload: payload });
		});
	},

	[types.ACTION_GET_AGREEMENT]: ({ commit }, payload) =>
	{
		commit(types.MUTATE_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_GET_AGREEMENT, payload: payload })

		return AgreementService.getAgreement(payload).then(response =>
		{
			commit(types.MUTATE_UPDATE_AGREEMENT, response.data);
			return response
		}).catch(error =>
		{
			commit(types.MUTATE_ADD_ERRORLOG_ENTRY, { reference: types.ACTION_GET_AGREEMENT, message: error });
		});
	},

	[types.ACTION_ADD_AGREEMENT]: ({ commit }, payload) =>
	{
		commit(types.MUTATE_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_ADD_AGREEMENT, payload: payload })

		return AgreementService.addAgreement(payload).then(response =>
		{
			commit(types.MUTATE_ADD_AGREEMENT, response.data);
			return response
		}).catch(error =>
		{
			commit(types.MUTATE_ADD_ERRORLOG_ENTRY, { reference: types.ACTION_ADD_AGREEMENT, message: error.response.statusText, payload: payload });
		});
	},

	[types.ACTION_UPDATE_AGREEMENT]: ({ commit }, payload) =>
	{
		commit(types.MUTATE_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_UPDATE_AGREEMENT, payload: payload })

		return AgreementService.updateAgreement(payload).then(response =>
		{
			commit(types.MUTATE_UPDATE_AGREEMENT, payload);
			return response
		}).catch(error =>
		{
			commit(types.MUTATE_ADD_ERRORLOG_ENTRY, { reference: types.ACTION_UPDATE_AGREEMENT, message: error.response.statusText, payload: payload });
		});
	},

	[types.ACTION_DELETE_AGREEMENT]: ({ commit }, payload) =>
	{
		commit(types.MUTATE_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_DELETE_AGREEMENT, payload: payload })

		return AgreementService.deleteAgreement(payload).then(response =>
		{
			commit(types.MUTATE_DELETE_AGREEMENT, payload);
			return response
		}).catch(error =>
		{
			commit(types.MUTATE_ADD_ERRORLOG_ENTRY, { reference: types.ACTION_DELETE_AGREEMENT, message: error.response.statusText, payload: payload });
		});
	}
}

export default
	{
		state,
		mutations,
		actions,
		getters
	}
